/**
 * Rotator dla elementów WhyUs
 * Cyklicznie podświetla każdy następny element co 5 sekund
 */

class WhyUsRotator {
    constructor() {
        this.items = document.querySelectorAll('.homepage-whyus .whyus__item');
        this.currentIndex = 0;
        this.interval = null;
        this.intervalDuration = 5000; // 5 sekund
        this.init();
    }

    init() {
        if (this.items.length === 0) return;
        
        // Ustaw pierwszy element jako aktywny
        this.setActiveItem(0);
        
        // Rozpocznij rotację
        this.startRotation();
    }

    setActiveItem(index) {
        // Usuń klasę aktywną ze wszystkich elementów
        this.items.forEach(item => item.classList.remove('whyus__item--active'));
        
        // Dodaj klasę aktywną do wybranego elementu
        if (this.items[index]) {
            this.items[index].classList.add('whyus__item--active');
        }
    }

    startRotation() {
        this.interval = setInterval(() => {
            // Przejdź do następnego elementu
            this.currentIndex = (this.currentIndex + 1) % this.items.length;
            this.setActiveItem(this.currentIndex);
        }, this.intervalDuration);
    }

    stopRotation() {
        if (this.interval) {
            clearInterval(this.interval);
            this.interval = null;
        }
    }

    destroy() {
        this.stopRotation();
        this.items.forEach(item => item.classList.remove('whyus__item--active'));
    }
}

// Eksportuj klasę
export { WhyUsRotator };

// Auto-inicjalizacja po załadowaniu DOM
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        new WhyUsRotator();
    });
} else {
    new WhyUsRotator();
}
